import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import { mutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { z } from 'zod';
import type { Role } from '../types/roles.type';

export const CreateRoleSchema = z.object({
  role: z.string().min(1, { message: 'Nama role tidak boleh kosong!' }),
  permissions: z.array(z.string()).optional(),
});

export type CreateRolePayload = z.infer<typeof CreateRoleSchema>;
export type CreateRoleResponse = ApiResponse<Role>;

export const createRole = async (
  payload: CreateRolePayload
): Promise<CreateRoleResponse> => {
  const url = '/role';

  return await apiClient.post(url, payload);
};

export function createRoleMutationOptions() {
  return mutationOptions<CreateRoleResponse, AxiosError, CreateRolePayload>({
    mutationFn: createRole,
  });
}
